<template>
    <div class="position-relative">
        <v-app class="p-4">
            <div class="col-md-8 mt-5 pt-5 mx-auto">
                <div class="row mt-5 pt-5 mx-auto">
                    <div class="col-md-6">
                        <v-autocomplete outlined
                                        clear-icon="mdi-close-circle-outline"
                                        prepend-inner-icon="fa fa-pencil-alt"
                                        clearable
                                        dense label="نوع حمله" @change="setChild($event)" :items="attackResons"
                                        item-value="reason" item-text="desc"></v-autocomplete>
                    </div>
                    <div class="col-md-6" v-if="child !== undefined">
                        <v-autocomplete outlined
                                        clear-icon="mdi-close-circle-outline"
                                        prepend-inner-icon="fa fa-pencil-alt"
                                        clearable
                                        dense label="دلیل حمله"
                                        :items="child"
                                        item-value="reason" v-model="reason" item-text="desc"></v-autocomplete>
                    </div>
                </div>
                <div class="row mx-auto py-0 my-0">
                    <div class="col-md-6">
                        <v-text-field outlined
                                      clear-icon="mdi-close-circle-outline"
                                      prepend-inner-icon="fa fa-pencil-alt"
                                      clearable
                                      dense label="آگهی" v-model="adsToken"></v-text-field>
                    </div>
                    <div class="col-md-6">
                        <v-text-field outlined
                                      clear-icon="mdi-close-circle-outline"
                                      prepend-inner-icon="fa fa-pencil-alt"
                                      clearable
                                      min="1"
                                      dense type="number"
                                      label="تعداد ضربات" v-model.number="attackCount"></v-text-field>
                    </div>
                </div>

                <div class="row mx-auto py-0 my-0">
                    <div class="col-md-6">
                        <v-text-field outlined
                                      clear-icon="mdi-close-circle-outline"
                                      prepend-inner-icon="fa fa-pencil-alt"
                                      type="number"
                                      clearable
                                      hint="تاخیر بر اساس دقیقه درج شود."
                                      dense label="تاخیر بین هر حمله"
                                      v-model="delay">
                        </v-text-field>
                    </div>
                    <div class="col-md-6"></div>
                </div>
                <div class="col-md-12 py-0" v-for="item in attackCount" :key="item">
                    <v-textarea outlined
                                clear-icon="mdi-close-circle-outline"
                                prepend-inner-icon="fa fa-pencil-alt"
                                clearable
                                dense
                                v-model="descriptions[item-1]"
                                :label="'توضیحات '+item">
                    </v-textarea>
                </div>
                <v-btn @click="sendAttack" class="submit-btn float-left">
                     <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                    ثبت حمله
                </v-btn>
            </div>
        </v-app>
    </div>
</template>

<script>
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";

export default {
    name: "attack",
    components: {TitleRibbon, ButtonTempl},
    data() {
        return {
            attackResons: [],
            attackCount: 1,
            child: [],
            reason: '',
            descriptions: [],
            token: null,
            delay: null
        }
    },
    methods: {
        getAttacks() {
            $.ajax({
                url: `${url}/divar/report/results`,
                type: 'GET',
                fn: this.getAttacks,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token
                },
                success: (data) => {
                    this.attackResons = data.data
                }
            })
        },
        sendAttack() {
            $.ajax({
                url: `${url}/divar/report/${this.adsToken}`,
                type: 'POST',
                fn: this.sendAttack,
                headers: {
                    'Authorization': Token,
                    ACCEPT: 'application/json',
                    "Content-Type": 'application/json',
                },
                data: JSON.stringify({
                    reason: this.reason,
                    count: this.attackCount,
                    description: this.descriptions,
                    delay: this.delay
                }),
                msg: true,
            })
        },
        setChild(value) {
            this.child = this.attackResons.find((x) => x.reason === value).children
        }
    },
    computed: {
        adsToken: {
            get() {
                return this.token;
            },
            set(value) {
                const temp = value.split("/");
                this.token = temp[temp.length - 1];
            }
        }
    },
    mounted() {
        this.getAttacks();
    }
}
</script>

<style>
.fa-pencil-alt {
    font-size: 12pt !important;
}
</style>